module.exports = __webpack_public_path__ + "static/media/createsegmentimg.062a2d08.png";